module.exports = __webpack_public_path__ + "img/yb3.87810ec4.jpg";